import { environment } from '../../../environments/environment';
import { IBanner } from '../interfaces/i-banner';

export const BANNERS: IBanner[] = [
  {
    src: environment.baseUrl + '/assets/imgs/banners/banner-6.png',
    link: ['restaurante', 'parrilla-del-sur'],
    alt: 'Parrilla Del Sur',
  },
  {
    src: environment.baseUrl + '/assets/imgs/banners/banner-2.png',
    link: ['categoria', 'italiana'],
    alt: 'Italiana',
  },
  {
    src: environment.baseUrl + '/assets/imgs/banners/banner-9.png',
    external: 'https://backoffice.mobo.com.br/#/onboarding?starter=true',
    alt: 'Assine Agora',
  },
  {
    src: environment.baseUrl + '/assets/imgs/banners/banner-8.png',
    link: ['home/4309100'],
    alt: 'Gramado',
  },
  {
    src: environment.baseUrl + '/assets/imgs/banners/banner-3.png',
    link: ['categoria', 'oriental'],
    alt: 'Oriental',
  },
  {
    src: environment.baseUrl + '/assets/imgs/banners/banner-4.png',
    link: ['restaurante', '08dc1daa-ce57-461c-84ef-3fdb13d63d2e'],
    alt: 'Al Nur - Restaurante Libanês',
  },
  {
    src: environment.baseUrl + '/assets/imgs/banners/banner-5.png',
    link: ['categoria', 'pizza'],
    alt: 'Pizza',
  },
];
